import { Typography } from "antd"
import Select from 'react-select'
import React, { useState } from 'react'

import { usePet } from '../../modules'

import Modal from "../resusable/modal"
import Confirm from "../resusable/confirm"
// import Amenities from './amenities'

const { Paragraph } = Typography

const ItemGroup = ({ toggle, visible, group, onComplete }) => {
    const [name, setName] = useState(group?.name)
    const [categories, setCategories] = useState(group?.categories.map(cat => ({ label: cat, value: cat })))
    const [unassigned, setUnassigned] = useState([])
    const [printer, setPrinter] = useState(group?.printer ? { label: group.printer.name, value: group.printer._id } : null)
    const [printers, setPrinters] = useState([])

    const [{ loading: catsLoading, error: catsError }] = usePet('unAssignedCategories', null, { notify: true, callback: ({ data }) => {
        let temp = [...group.categories, ...data]
        temp = temp.map(cat => ({ label: cat, value: cat }))
        setUnassigned(temp)
    } })

    usePet('printers', { page: 1, limit: 100 }, { notify: true, callback: ({ data }) => {
        setPrinters(data?.printers?.map(printer => ({ label: printer.name, value: printer._id })))
    } })

    const [{ loading }, execute] = usePet('editItemGroup', {
        id: group?._id,
        name,
        categories: categories?.map(cat => cat?.value),
        printer: printer ? printer?.value : null,
    }, { notify: true, hasFile: true, callback: (_, notif, ops) => {
        notif('Group has been updated', ops('success'))
        onComplete()
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Saving group...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/2 lg:w-1/3 xl:w-1/3"
            title="Item Group"
            toggle={toggle}
            visible={visible}>
            <div className="w-full bg-white">
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Group Name
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={ e => setName(e.target.value) }
                            placeholder="Kitchen" />
                    </div>
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Default Printer
                        </label>
                        <Select
                            value={ printer }
                            options={ printers }
                            onChange={ setPrinter } />
                    </div>
                </div>                
                <div className="flex flex-wrap mb-6">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Group Categories
                    </label>
                    <br/>
                    <Select
                        isMulti
                        value={ categories }
                        options={ unassigned }
                        onChange={ setCategories } />
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={ () => Confirm({
                    title: 'Save Changes?',
                    desc: 'Are you sure you want to save these changes?',
                    okText: 'Save Changes',
                    onOk: execute
                }) } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default ItemGroup